<template>
  <ListingsFilterControl :label="label">
    <VDropdown
      :model-value="modelValue"
      :options="LISTINGS_DATE_OPTIONS"
      @update:model-value="handleUpdateModelValue"
    />
  </ListingsFilterControl>
</template>

<script lang="ts" setup>
  // Types
  import type { PropType } from 'vue';
  import type { EDateFilterOptions } from '~/misc/listings/types';
  import { EAnalyticsEvent } from '~/misc/services/analytics/types';

  // Config
  import { LISTINGS_DATE_OPTIONS } from '~/misc/listings/config';

  // Utils
  import { eventBus } from '~/misc/utils/event-bus';

  // Components
  import ListingsFilterControl from '~/misc/listings/filters/control/ListingsFilterControl.vue';
  import VDropdown from '~/misc/v-dropdown';

  const emit = defineEmits<{
    (e: 'update:modelValue', value: EDateFilterOptions | null): void;
  }>();

  defineProps({
    modelValue: {
      type: String as PropType<EDateFilterOptions | null>,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
  });

  const handleUpdateModelValue = (value: EDateFilterOptions | null) => {
    eventBus.emit(EAnalyticsEvent.DASHBOARD_FILTERS_DATE_CHANGED, { value });

    emit('update:modelValue', value);
  };
</script>
